export const CHECK_ROOT_DETECTION_REQUEST = 'CHECK_ROOT_DETECTION_REQUEST';
export const CHECK_ROOT_DETECTION_SUCCESS = 'CHECK_ROOT_DETECTION_SUCCESS';
export const CHECK_ROOT_DETECTION_FAILURE = 'CHECK_ROOT_DETECTION_FAILURE';
